function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M0 0h20v20H0z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#5F6C7D",
  d: "M10 10.14L7.36 7.5 6.18 8.68 10 12.5l3.82-3.82-1.18-1.18z"
});

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      "width": 30,
      "height": 30
    },
    viewBox: "0 0 20 20",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "static/media/search_arrow_down.cc945da7.svg";
export { SvgComponent as ReactComponent };